export enum StockUnit {
  GRAMS = 'g',
  KILOGRAMS = 'kg',
  MILLILITERS = 'ml',
  LITERS = 'l',
  UNITS = 'un',
  PIECES = 'pcs',
}

export const STOCK_UNIT_LABELS = {
  [StockUnit.GRAMS]: 'Gramos',
  [StockUnit.KILOGRAMS]: 'Kilogramos',
  [StockUnit.MILLILITERS]: 'Mililitros',
  [StockUnit.LITERS]: 'Litros',
  [StockUnit.UNITS]: 'Unidades',
  [StockUnit.PIECES]: 'Piezas',
};
